var map = {
	"./bg-br.jpg": "imPH",
	"./bg-cl.jpg": "juNj",
	"./bg-es.jpg": "lTT7",
	"./bg-uy.jpg": "YP+P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vzNS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/godfather ^\.\/bg\-.*\.jpg$
// module id = vzNS
// module chunks = 1